import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { DocumentoSpesaDTO } from "../dto/documento-spesaDTO";
import { DocumentoSpesaVO } from "../vo/documento-spesaVO";

@Injectable({ providedIn: "root" })
export class MapperDocumentoSpesa
  implements MapperInterface<DocumentoSpesaDTO, DocumentoSpesaVO> {
  constructor() { }

  convertVoToDto(documentoSpesaVO: DocumentoSpesaVO): DocumentoSpesaDTO {
    if (documentoSpesaVO != null) {
      const documentoSpesaDTO = new DocumentoSpesaDTO();

      documentoSpesaDTO.cig = documentoSpesaVO.cig;
      documentoSpesaDTO.cup = documentoSpesaVO.cup;
      documentoSpesaDTO.lineaFinanziamento =
        documentoSpesaVO.lineaFinanziamento;
      documentoSpesaDTO.pad = documentoSpesaVO.pad;
      documentoSpesaDTO.importo = documentoSpesaVO.importo;
      documentoSpesaDTO.importoNetto = documentoSpesaVO.importoNetto;
      documentoSpesaDTO.scadenzaDurc = documentoSpesaVO.scadenzaDurc;
      documentoSpesaDTO.iva = documentoSpesaVO.iva;
      documentoSpesaDTO.splitPayment = documentoSpesaVO.splitPayment;

      return documentoSpesaDTO || new DocumentoSpesaDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(documentoSpesaDTO: DocumentoSpesaDTO): DocumentoSpesaVO {
    if (documentoSpesaDTO != null) {
      const documentoSpesaVO = new DocumentoSpesaVO();

      documentoSpesaVO.importo = documentoSpesaDTO.importo;
      documentoSpesaVO.importoNetto = documentoSpesaDTO.importoNetto;
      documentoSpesaVO.cig = documentoSpesaDTO.cig;
      documentoSpesaVO.cup = documentoSpesaDTO.cup;
      documentoSpesaVO.lineaFinanziamento =
        documentoSpesaDTO.lineaFinanziamento;
      documentoSpesaVO.pad = documentoSpesaDTO.pad;
      documentoSpesaVO.scadenzaDurc = documentoSpesaDTO.scadenzaDurc;
      documentoSpesaVO.iva = documentoSpesaDTO.iva;
      documentoSpesaVO.splitPayment = documentoSpesaDTO.splitPayment;

      return documentoSpesaVO || new DocumentoSpesaVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(docList: DocumentoSpesaVO[]): DocumentoSpesaDTO[] {
    const docSpesaDTOList = new Array<DocumentoSpesaDTO>();
    docList.forEach((vo) => {
      docSpesaDTOList.push(this.convertVoToDto(vo));
    });

    return docSpesaDTOList || new Array<DocumentoSpesaDTO>();
  }

  convertListDtoToVo(docSpesaDTOList: DocumentoSpesaDTO[]): DocumentoSpesaVO[] {
    // console.log("[MapperSettori] attoDTOList => attoDTOList");
    // console.log("attoDTOList", attoDTOList);
    const documentoSpesaVOList = new Array<DocumentoSpesaVO>();
    docSpesaDTOList.forEach((dto) => {
      documentoSpesaVOList.push(this.convertDtoToVo(dto));
    });

    return documentoSpesaVOList || new Array<DocumentoSpesaVO>();
  }
}
